import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const IraishaKbn = props => {
  return <Dropdown.Static kubunKey='iraisha_kbn' {...props} />
}
